/**
 * src/domains/applications/applications.store.ts
 *
 * Reactive store for job applications.
 */
import { createStore } from '../../infra/sync';

import { fetchMyApplications } from './applications.api';
import type { Application } from './applications.types';

export interface ApplicationState {
  myApplications: Application[];
  loading: boolean;
  error: string | null;
}

export const applicationStore = createStore<ApplicationState>({
  cacheKey: 'pioneer_marketplace_applications',
  initialValue: { myApplications: [], loading: false, error: null },
});

export async function loadMyApplications(): Promise<void> {
  applicationStore.patchState({ loading: true, error: null });
  try {
    const myApplications = await fetchMyApplications();
    applicationStore.patchState({ myApplications, loading: false });
  } catch (err) {
    applicationStore.patchState({
      loading: false,
      error: err instanceof Error ? err.message : 'Failed to load applications',
    });
  }
}
